export default {"src":"/_next/static/media/data-governance.ae54ee76.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};